export default __webpack_public_path__ + "static/php-icon-0006752ae59c2c59130acf4d58521bc5.svg";